import {
  makeStyles,
  shorthands,
  tokens,
  typographyStyles,
} from '@fluentui/react-components';
import { btnStyle } from '@bingads-webui-campaign/shared-image-experience-styles';

export const filesPerRowInPreviewGrid = '--files-per-row-in-preview-grid';

export const getFileUploadContainerStyles = (_, { palette = {} }) => ({
  container: {
    '& .file-drag-container': {
      '& .hidden': {
        display: 'none',
      },
      '& .file-upload-button': {
        ...shorthands.padding(
          tokens.spacingVerticalNone,
          '48px',
          tokens.spacingVerticalNone,
          tokens.spacingHorizontalXXXL
        ),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      '& .file-picker-react-wrapper': {
        '& .file-picker-btn': {
          extend: btnStyle()['.btn-default'],
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          float: 'none',
          marginLeft: 0,
          maxWidth: '72px',
          overflow: 'hidden',
          ...typographyStyles.body1,

          '& ~ .file-text': {
            display: 'inline-block',
            border: 'none',
          },
        },
      },
      '& .file-picker-react-wrapper.disabled': {
        visibility: 'hidden',
      },
      '& .file-drag-wrapper': {
        height: 'fit-content',
        '& .file-dragger-wrapper': {
          boxSizing: 'border-box',
          padding: '12.5px 0',
        },
        '& .file-dragger': {
          padding: '12.5px 0',
          boxSizing: 'border-box',
          ...shorthands.border('1px'),
          ...shorthands.borderStyle('dashed'),
          ...shorthands.borderColor(palette.colorNeutralBackground1),
          ...shorthands.borderRadius(tokens.borderRadiusXLarge),
        },
        '& .file-default-wrapper': {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          paddingLeft: tokens.spacingHorizontalXXXL,
          '& .file-upload-icon': {
            display: 'none !important',
          },
          '& .file-upload-text': {
            display: 'inline-block',
            marginTop: '0px',
          },
        },
      },
    },
  },
});

export const getFileUploadButtonStyles = (_, { palette = {} }) => ({
  button: {
    display: 'flex',
    width: 'fit-content',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    boxSizing: 'border-box',
    position: 'relative',
    overflow: 'hidden',
    ...shorthands.border('1px'),
    ...shorthands.borderStyle('dashed'),
    ...shorthands.borderColor(palette.colorNeutralBackground1),
    ...shorthands.borderRadius(tokens.borderRadiusXLarge),

    '& .file-picker-container': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',

      '& div': {
        height: '100%',
      },

      '& .hidden': {
        display: 'none',
      },
      '& .file-picker-btn': {
        height: '100%',
        cursor: 'pointer',
        opacity: '0.001',
        extend: btnStyle()['.btn-default'],
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        float: 'none',
        marginLeft: 0,
        maxWidth: '72px',
        overflow: 'hidden',
        ...typographyStyles.body1,

        '& ~ .file-text': {
          display: 'inline-block',
          border: 'none',
        },
      },
    },
  },
});

export const useFileUploadStyles = makeStyles({
  filesContainer: {
    display: 'grid',
    ...shorthands.gap(tokens.spacingVerticalM, tokens.spacingHorizontalXL),
    gridTemplateColumns: `repeat(var(${filesPerRowInPreviewGrid}), 1fr)`,
  },
  fileContainer: {
    display: 'flex',
    maxWidth: '100%',
    alignItems: 'center',
    position: 'relative',
    boxShadow: tokens.shadow4,
    justifyContent: 'space-between',
    backgroundColor: tokens.colorNeutralBackground2,
    ...shorthands.overflow('hidden'),
    ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalS),
    ...shorthands.gap(tokens.spacingHorizontalS, tokens.spacingVerticalNone),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
  },
  filePreviewImageIcon: {
    display: 'flex',
    position: 'relative',
    ...shorthands.flex(0),
    justifyContent: 'center',
    alignItems: 'center',

    '& > span': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: tokens.colorNeutralBackground2,
      ...shorthands.borderRadius('100%'),
      ...shorthands.padding(
        tokens.spacingVerticalXS,
        tokens.spacingHorizontalXS
      ),
    },
  },
  filePreviewContent: {
    ...shorthands.flex(1),
    ...shorthands.overflow('hidden'),
    '& > div': {
      ...shorthands.margin(
        tokens.spacingVerticalXS,
        tokens.spacingHorizontalNone
      ),
    },
  },
  uploadFilesButton: {
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    ...shorthands.padding(tokens.spacingVerticalS, tokens.spacingHorizontalS),

    '& span': {
      marginTop: tokens.spacingVerticalS,
    },
  },
  fileUploadError: {
    ...shorthands.padding(
      tokens.spacingVerticalS,
      tokens.spacingHorizontalNone,
      tokens.spacingVerticalNone,
      tokens.spacingHorizontalNone
    ),
    color: tokens.colorPaletteRedBackground3,
  },
});
